import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { usePostHog } from "posthog-js/react";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum, TopicInsightsScheduleDestinationEnum, TopicInsightsScheduleTypeEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import moment from "moment";
import insightReportSelectors from "~/store/insightReports/selectors";
import insightsSchema from "~/forms/InsightsForm/insightsSchema";
import insightReportsActionCreators from "~/store/insightReports/actions";
import InsightsForm from "~/forms/InsightsForm";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const InsightsCreateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(insightReportSelectors.getAction);
  const status = useSelector(insightReportSelectors.getStatusByReport("+"));
  const error = useSelector(insightReportSelectors.getErrorByReport("+"));
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const defaultValues = {
    scheduleType: TopicInsightsScheduleTypeEnum.WEEKLY,
    scheduleDayOfWeek: "4",
    scheduleTimeOfDay: moment("10:00:00", "hh:mm:ss").toISOString(),
    scheduleDestination: TopicInsightsScheduleDestinationEnum.SLACK,
    excludedTopicIds: []
  };
  const {
    handleSubmit,
    control,
    reset,
    watch
  } = useForm({
    resolver: yupResolver(insightsSchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(insightReportsActionCreators.createStarted(data, _ref => {
      let {
        data: newTopic
      } = _ref;
      if (newTopic) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("InsightsCreateModal.reportInProgress"),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
    posthog.capture(`Insights Report Create – Save`, {
      ...data
    });
  });
  const onCancel = () => {
    dispatch(insightReportsActionCreators.actionChanged(null, null));
    posthog.capture(`Insights Report Create – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("InsightsCreateModal.createReport"),
    onClose: onCancel,
    maxWidth: "640px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error)), /*#__PURE__*/React.createElement(InsightsForm, {
    control: control,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("common.actions.create")))));
};
export default InsightsCreateModal;